import { AwazeLogoColor, AwazeLogoDark, AwazeLogoLight, AwazeLogoReversed, } from './assets/awaze';
import { CoreResmanLogo } from './assets/coreInternalResman';
import { CottagesLogoColor, CottagesLogoDark, CottagesLogoLight, CottagesLogoReversed, } from './assets/cottages';
import { DansommerLogo } from './assets/dansommer';
import { FincallorcaLogo, FincallorcaLogoLight } from './assets/fincallorca';
import { HOLogoColor, HOLogoDark, HOLogoLight, HOLogoReversed, } from './assets/hoseasons';
import { NovasolLogoColor, NovasolLogoDark, NovasolLogoLight, NovasolLogoReversed, } from './assets/novasol';
import { PartOfAwazeLogo, PartOfAwazeLogoLight } from './assets/partofawaze';
export const logoConfig = {
    awaze: {
        color: AwazeLogoColor,
        dark: AwazeLogoDark,
        light: AwazeLogoLight,
        reversed: AwazeLogoReversed,
        default: AwazeLogoColor,
        header: AwazeLogoReversed,
    },
    novasol: {
        color: NovasolLogoColor,
        dark: NovasolLogoDark,
        light: NovasolLogoLight,
        reversed: NovasolLogoReversed,
        default: NovasolLogoColor,
        header: NovasolLogoColor,
    },
    novasolOwner: {
        color: NovasolLogoColor,
        dark: NovasolLogoDark,
        light: NovasolLogoLight,
        reversed: NovasolLogoReversed,
        default: NovasolLogoReversed,
        header: NovasolLogoReversed,
    },
    'cottages.com': {
        color: CottagesLogoColor,
        dark: CottagesLogoDark,
        light: CottagesLogoLight,
        reversed: CottagesLogoReversed,
        default: CottagesLogoColor,
        header: CottagesLogoReversed,
    },
    hoseasons: {
        color: HOLogoColor,
        dark: HOLogoDark,
        light: HOLogoLight,
        reversed: HOLogoReversed,
        default: HOLogoColor,
        header: HOLogoReversed,
    },
    coreInternal: {
        default: AwazeLogoReversed,
        header: AwazeLogoReversed,
        custom: CoreResmanLogo,
    },
    dansommer: {
        default: DansommerLogo,
    },
    partofawaze: {
        default: PartOfAwazeLogo,
        light: PartOfAwazeLogoLight,
    },
    fincallorca: {
        default: FincallorcaLogo,
        header: FincallorcaLogo,
        light: FincallorcaLogoLight,
    },
};
export const getLogoConfig = (brand) => {
    return logoConfig[brand];
};
//# sourceMappingURL=logo-config.js.map